import { useState } from 'react';
import { faqItems } from '@/mocks/guaHome';

export default function FaqBlock() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-amber-50/40">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          {/* left rail */}
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">07 · 说明</span>
              <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Notes</span>
            </div>
            <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">关于收录与使用说明</h2>
            <p className="mt-3 text-sm leading-relaxed text-stone-600">
              53吃瓜 定位是<b>整理向补漏站</b>：把往期精选、合集存档和目录老帖按时间线归拢好。分不清先看哪块，或不清楚本站收录口径，看这几条就够了。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-stone-600 ring-1 ring-stone-200">
                <i className="ri-timer-flash-line text-red-500" /> 补录中
              </span>
              <span className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-stone-600 ring-1 ring-stone-200">
                <i className="ri-archive-line text-amber-600" /> 老帖目录 860+
              </span>
              <span className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-stone-600 ring-1 ring-stone-200">
                <i className="ri-calendar-check-line text-emerald-600" /> 每月例行复核
              </span>
            </div>
          </div>

          {/* accordion */}
          <div className="space-y-3">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border bg-white transition-colors ${open ? 'border-red-200' : 'border-stone-200/80'}`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className={`flex items-center gap-3 text-[15px] font-bold ${open ? 'text-red-600' : 'text-stone-900'}`}>
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-[11px] font-black ${
                          open ? 'bg-red-600 text-white' : 'bg-stone-100 text-stone-500'
                        }`}
                      >
                        Q
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`${open ? 'ri-subtract-line' : 'ri-add-line'} shrink-0 text-lg text-stone-400 transition-transform ${open ? 'rotate-180' : ''}`}
                    />
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-stone-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}